import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { FaceMap, ScreenForList } from '../model/store.model';
import { MatDialog } from '@angular/material/dialog';
import { PlayerComponent } from '../../spots/player/player.component';
import { ChartOptions } from 'chart.js';
import { ScreenService } from '../services/screen.service';

@Component({
    selector: 'app-map-item',
    templateUrl: './map-item.component.html',
    styleUrls: ['./map-item.component.scss'],
})
export class MapItemComponent implements OnInit {
    @Input() faceItem: FaceMap;
    @Output() openInfoOutput = new EventEmitter<number>();
    @Output() clickScreenFromMapOutput =
        new EventEmitter<SelectFaceFromMapOutput>();
    @Output() selectFaceFromMapOutput =
        new EventEmitter<SelectFaceFromMapOutput>();
    @Output() closePopup = new EventEmitter<any>();
    @Input() mapMode: boolean = false;
    @Input() recapMode?: boolean = false;
    @Input() screenItem: ScreenForList;
    /**
     * Pour afficher les ODV totaux ou /jour
     */
    @Input() hasDateSelected: boolean = false;
    @Input() mini?: boolean = false;
    baseUrl: string;
    public isOdvChartDisplayed: boolean = false;

    constructor(private dialog: MatDialog, public screen$: ScreenService) {
        this.baseUrl = environment.apiBaseStore;
    }
    ngOnInit(): void {
        this.chartData.datasets[0].data = [
            this.faceItem?.o?.m[12],
            this.faceItem?.o?.m[18],
            this.faceItem?.o?.m[25],
            this.faceItem?.o?.m[35],
            this.faceItem?.o?.m[45],
            this.faceItem?.o?.m[55],
            this.faceItem?.o?.m[65],
        ];

        this.chartData.datasets[1].data = [
            this.faceItem?.o?.f[12],
            this.faceItem?.o?.f[18],
            this.faceItem?.o?.f[25],
            this.faceItem?.o?.f[35],
            this.faceItem?.o?.f[45],
            this.faceItem?.o?.f[55],
            this.faceItem?.o?.f[65],
        ];
    }

    //#region ChartOptions

    public labels = [
        '12-17',
        '18-24',
        '25-34',
        '35-44',
        '45-54',
        '55-64',
        '65 +',
    ];
    public chartData = {
        labels: this.labels,
        datasets: [
            {
                label: 'Femmes',
                data: [15, 10, 5, 2, 7, 26, 11, 9],
                borderColor: '#FFCF55',
                backgroundColor: '#FFCF554b',
                borderWidth: 2,
                borderRadius: 5,
                borderSkipped: false,
                // inflateAmount: 0.1,
                barPercentage: 0.7,
                // categoryPercentage: 1,
            },
            {
                label: 'Hommes',
                data: [2, 5, 10, 15, 20, 25, 30, 35],
                borderColor: '#0B002C',
                backgroundColor: '#0b002c4b',
                borderWidth: 2,
                borderRadius: 5,
                borderSkipped: false,
                // inflateAmount: 0.1,
                barPercentage: 0.7,
                // categoryPercentage: 1,
            },
        ],
    };

    public chartOptions: ChartOptions = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: false,
            },
        },
        scales: {
            x: {
                grid: {
                    // lineWidth: 0
                    display: false,
                    // tickLength: 0,
                    // tickWidth: -100
                },
                ticks: {
                    //    display:
                },
            },
            y: {
                display: false,
            },
        },
    };

    //#endregion ChartOptions

    /**
     * Appelée au click de selection sur une face dans la liste de Gauche
     * @param face Face sélectionnée
     * @param screenItem Ecran de la face Sélectionnée
     */
    clickScreenFromMap(face: FaceMap, screenItem: ScreenForList) {
        this.clickScreenFromMapOutput.emit({
            face: face,
            screenItem: screenItem,
        });
    }

    openInfo(screenId: number) {
        const elem = document.getElementById(this.faceItem.id.toString());

        elem.setAttribute('tabindex', '-1');
        elem.focus();

        this.openInfoOutput.emit(screenId);
    }

    /**
     * Appelée au click de selection sur une face dans la map
     * @param face Face sélectionnée
     * @param screenItem Ecran de la face Sélectionnée
     */
    selectFaceFromMap(face: FaceMap, screenItem: ScreenForList) {
        this.selectFaceFromMapOutput.emit({
            face: face,
            screenItem: screenItem,
        });
    }

    openImgDetail() {
        const detailImgDialogRef = this.dialog.open(PlayerComponent);

        detailImgDialogRef.componentInstance.fileStorageId = this.faceItem.st;
        detailImgDialogRef.componentInstance.loadVideo();
    }

    /**
     * Affiche/Masque le graphique des ODVs
     */
    showOdvChart() {
        this.isOdvChartDisplayed = !this.isOdvChartDisplayed;
    }
    
    close(){
        this.closePopup.emit();
    }
}


/**
 * Output des fonctions :
 * - selectFaceFromMap
 * - clickScreenFromMap
 */
export interface SelectFaceFromMapOutput {
    /**
     * Face Selectionnée dans l'infoWindow
     */
    face: FaceMap;
    /**
     * Ecran contenant la face sélectionnée dans l'infoWindow
     */
    screenItem: ScreenForList;
}
